import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: top;
  width: 100%;
  height: 100%;
`;
